import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import HorizontalSelector from "../../../common/inputs/HorizontalSelector";
import { useEmployee } from "../../../../providers/EmployeeProvider";

export default function DriverActiveStateSelector() {
  const { t } = useTranslation();
  const { active, setActive, loading } = useEmployee();

  const items = useMemo(() => [
    t("myMissions:driverActiveStateSelector:working"), 
    t("myMissions:driverActiveStateSelector:notWorking")
  ], [t]);

  return (
    <HorizontalSelector
      loading={loading}
      items={items}
      value={!!active ? 0 : 1}
      onChange={useCallback((v) => setActive(v === 0 ? true : false), [setActive])}
    />
  );
}
